<template>
    <div>
        <b-row>
            <b-col>
                <b-button v-b-modal="id +'modal-prevent-closing'"
                          variant="outline-primary" :aria-describedby="describedBy">
                    Attach Document(s)
                </b-button>
            </b-col>
        </b-row>

        <b-modal hide-footer
                 :id="id +'modal-prevent-closing'"
                 ref="modal"
                 title="Add File Attachment"
                 @show="resetModal"
                 @hidden="resetModal"
                 @ok="handleOk">

            <form ref="form" @submit.stop.prevent="handleSubmit">
                <b-form-group
                    :state="$v.type.$dirty ? !$v.type.$error : null"
                    label="Type of Attachment"
                    label-for="type-input"
                    invalid-feedback="Type of Attachment is required">
                    <b-form-select id="type-input" v-model="type"
                        :state="$v.type.$dirty ? !$v.type.$error : null"
                        :options="attachmentTypeOptions">
                        <template v-slot:first>
                            <option :value="null" disabled>-- Please select an option --</option>
                        </template>
                    </b-form-select>
                </b-form-group>

                <b-form-group v-if="type === 'OT'"
                              :state="$v.othType.$dirty ? !$v.othType.$error : null"
                              label="Other Type of Attachment"
                              label-for="othType-input"
                              invalid-feedback="Other Type of Attachment is required">
                    <b-form-input id="othType-input" v-model="othType"
                           :state="$v.othType.$dirty ? !$v.othType.$error : null"
                           >
                    </b-form-input>
                </b-form-group>

              <b-form-group v-if="type === 'W2'" label="Year(s):" :state="$v.selected.$dirty?!$v.selected.$error:null" :validator="$v.selected" invalid-feedback="Select at least 1 year">
                <b-form-checkbox-group v-if="startYear" v-model="selected" :state="$v.selected.$dirty?!$v.selected.$error:null">
                  <b-form-checkbox v-for="n in numYears" :value="n-1+startYear" v-bind:key="n">{{n-1+startYear}}</b-form-checkbox>
                </b-form-checkbox-group>
                <div v-else class="text-danger">
                  Please select start date first.
                </div>

              </b-form-group>

              <b-form-group label="Type of paystub" :state="$v.firstOrLast.$dirty?!$v.firstOrLast.$error:null" :validator="$v.firstOrLast" invalid-feedback="Select one option" v-if="type==='PS' && (needsFirstPaystub || needsLastPaystub)">
                <b-form-radio-group :state="$v.firstOrLast.$dirty?!$v.firstOrLast.$error:null">
                  <b-form-radio v-model="firstOrLast" name="First" value="First" v-if="needsFirstPaystub">First</b-form-radio>
                  <b-form-radio v-model="firstOrLast" name="Last" value="Last" v-if="needsLastPaystub">Last</b-form-radio>
                </b-form-radio-group>
              </b-form-group>



                <b-form-group
                    :state="$v.file.$dirty ? !$v.file.$error : null"
                    label="File to Attach"
                    label-for="file-input"
                    :validator="$v.file"
                    :invalid-feedback="file?'Invalid format':'File to Attach is required'">
                    <b-form-file
                        id="file-input"
                         v-model="file"
                         accept="application/pdf, image/*"
                         :state="$v.file.$dirty ? !$v.file.$error : null"
                         placeholder="Choose a file or drop it here..."
                         drop-placeholder="Drop file here...">
                    </b-form-file>
                </b-form-group>
                <div class="text-muted">PDF and Image files are accepted.</div>
                <b-button type="submit" variant="primary" :disabled="isDisabled">Submit</b-button>
            </form>
        </b-modal>
    </div>
</template>

<script>
    import axios from "axios"
    import { required, requiredIf } from 'vuelidate/lib/validators'
    import maxFileSize from '@/validators/maxFileSize'
    import fileType from "@/validators/fileType"
    const atLeastOneChecked = (obj, parent,model) => parent.type==='W2' && parent.$props.startYear? obj.length>0:true;
    const atLeastOnePaystubTypeSelectedIfNeeded = (obj, parent, model) => {
      return parent.type === 'PS' ? (!parent.$props.overTwoYears || (parent.needsFirstPaystub || parent.needsLastPaystub) && obj != null) : true;
    }

    export default {
        data(){
            return {
                type: null,
                file: null,
                othType: null,
                isDisabled: false,
                selected: [],
                firstOrLast: null
            }
        },
        props: {
            attachmentTypeOptions: [Array],
            id: [String],
            describedBy: [String],
            startYear: [Number],
            numYears: [Number],
            overTwoYears: [Boolean],
            needsFirstPaystub: [Boolean],
            needsLastPaystub: [Boolean],
        },
        validations: {
            file: { required, maxFileSize: maxFileSize(), fileType: fileType() },
            type: { required },
            othType: { required: requiredIf(function(){ return this.type === 'OT'})},
            selected: {atLeastOneChecked},
            firstOrLast: {
              atLeastOnePaystubTypeSelectedIfNeeded
            }
        },
        methods: {
            checkFormValidity(){
                const valid = this.$refs.form.checkValidity()
                return valid
            },
            resetModal(){
                this.name = null
            },
            handleOk(bvModalEvt){
                bvModalEvt.preventDefault()
                this.handleSubmit()
            },
            handleSubmit(){
                this.$v.$touch()
                if(this.$v.$invalid){
                    return
                }
                this.isDisabled = true
                const fd2 = new FormData()
                fd2.append('file', this.file)
                fd2.append('type', this.type)
                if(this.othType != null){
                    fd2.append('othType', this.othType)
                }
                else if(this.type==='W2'){
                  fd2.append('othType',this.selected.join(","))
                }
                else if(this.overTwoYears && this.type==='PS'){
                  fd2.append('othType',this.firstOrLast)
                }
                axios.post(`${process.env.VUE_APP_API_BASE_URL}/attachments/new`, fd2)
                    .then(response => {
                        this.file = null
                        this.type = null
                        this.othType = null
                        this.$emit('attachment-added', response.data)
                    })
                    .catch(error=>{
                        this.$emit('attachment-failed', error.data)
                    })
                    .finally(()=>{
                        this.$v.$reset()
                        let modalId = this.id + 'modal-prevent-closing'
                        this.$nextTick(() => {
                            this.isDisabled = false
                            this.$bvModal.hide(modalId)
                        })
                    })
            }
        }
    }
</script>